import React, {useEffect, useState} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import {CircularProgress} from "@mui/material";
import logo from '../assets/dvstaff.png'
import PromoTable from "../components/PromoTable";
import CompanionInstructions from '../documents/CompanionProcessRedemption.pdf';
import EmployeeDependInstructions from '../documents/EmployeeDependentRedemption.pdf';


let guid = (new URL(document.location).searchParams.get('guid'))

const PromoCode = () => {


    const [empGUID, setEmpGUID] = useState(guid === null ? '' : guid)
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState([])
    const [promoCodes, setPromoCodes] = useState([])

    useEffect(() => {
        onSearch()
    }, [])


    const onSearch = () => {
        if (empGUID.length !== 36) {
            toast.error('Invalid Employee ID')
        } else if (!isLoading && empGUID.length === 36) {
            getToken(empGUID)
        } else {

        }
    }

    const getToken = async (GUID) => {
        setIsLoading(true);
        let response = await axios.post(
            "https://apidv.us.auth0.com/oauth/token",
            {
                "client_id": process.env.REACT_APP_AUTH0APPKEY,
                "client_secret": process.env.REACT_APP_AUTH0APPSECRET,
                "audience": "https://api-uat.deervalley.com/hrapi",
                "grant_type": "client_credentials"
            },
            {headers: {"content-type": "application/json"}}
        ).then((response) => {
            const auth0Token = response.data.access_token;

            getPromoCodes(GUID, auth0Token)
        }).catch((error) => {
            toast.error('Unable to authenticate')
            setIsLoading(false);
        });
    }

    const getPromoCodes = async (GUID, auth0Token) => {
        try {
            await axios.get(process.env.REACT_APP_GET_PROMO + GUID,
                {headers: {Authorization: 'Bearer ' + auth0Token}})
                .then(res => {
                    if (res.data !== '' && data.guid !== '') {
                        setData(prev => res.data)
                        setPromoCodes(prev => res.data.promoCodes)
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        toast.error('This is not a valid request')
                    }
                })
                .catch((e) => {
                    toast.error('Invalid Request')
                    setIsLoading(false);
                });
        } catch (err) {
            toast.error('An error has occurred while fetching the records')
            setIsLoading(false);
        }

    }

    return (
        <div>
            <img src={logo} alt="DV Logo"
                 style={{width: '200px', height: 'auto', display: 'block', margin: 'auto', marginTop: '10px'}}/>
            <p> AMC/Ikon Pass Promos For Employees</p>
            <header className="App-header">
                <p>
                    {!isLoading && data.fName !== undefined && `${data.fName} -  Below are your available AMC/Ikon promo codes.`}
                </p>
                <p style={{color: 'red',textAlign: 'left', marginLeft: '3vw'}}>
                    {!isLoading && data.fName !== undefined && promoCodes.length > 0 && `IMPORTANT: Please note that after you assign  a passholder, you will have the option to add an Ikon pass if you wish.
                     You are expected to use your Deer Valley Staff/Dependent/Designate ID to ski at Deer Valley. These AMC perks are specifically for skiing at other AMC partner resorts.`}
                </p>
                {isLoading &&
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><CircularProgress
                        color="secondary"/></div>}
                <div>
                    {promoCodes.length > 0 && <PromoTable promos={promoCodes}/>}
                    {promoCodes.length === 0 && !isLoading &&
                        <p style={{color: 'red'}}>There are no promo codes for this employee</p>}
                </div>
            </header>
            <div style={{textAlign: 'left', marginLeft: '3vw'}}>
                {promoCodes.length > 0 &&
                    <p style={{fontSize: '0.75em'}}>For employee or dependents, copy codes and then <a
                        href="https://account.ikonpass.com/promocode" target="_blank" style={{color: '#03c8ff'}}>Click
                        Here to
                        Redeem</a></p>}
                {promoCodes.length > 0 &&
                    <p style={{fontSize: '0.75em'}}>&nbsp;&nbsp;&nbsp;&nbsp;&#8226;&nbsp;&nbsp;For step by step
                        instructions, click <a href={EmployeeDependInstructions}
                                               target="_blank" style={{color: '#03c8ff'}}>Here</a></p>}
                {promoCodes.length > 0 &&
                    <p style={{fontSize: '0.75em'}}>For designate/companion pass, send them their code along with
                        this <a href={CompanionInstructions} target="_blank" style={{color: '#03c8ff'}}> Link</a></p>}
            </div>

        </div>
    );
};

export default PromoCode;